import { AxiosInstance } from 'axios'
import {
    CustomField,
    CustomFieldCreate,
    CustomFieldUpdate,
    ListCustomFieldsParams,
    PaginatedCustomFieldResponse,
} from './custom-field.type'

export class CustomFieldApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all custom fields with pagination
     */
    async list(params?: ListCustomFieldsParams): Promise<PaginatedCustomFieldResponse> {
        const response = await this.client.get<PaginatedCustomFieldResponse>('/custom-fields', {
            params,
        })
        return response.data
    }

    /**
     * Get a single custom field by ID
     */
    async findOne(id: string): Promise<CustomField> {
        const response = await this.client.get<CustomField>(`/custom-fields/${id}`)
        return response.data
    }

    /**
     * Create a new custom field
     */
    async create(payload: CustomFieldCreate): Promise<CustomField> {
        const response = await this.client.post<CustomField>('/custom-fields', payload)
        return response.data
    }

    /**
     * Update a custom field
     */
    async update(id: string, payload: CustomFieldUpdate): Promise<CustomField> {
        const response = await this.client.put<CustomField>(`/custom-fields/${id}`, payload)
        return response.data
    }

    /**
     * Delete a custom field (soft delete)
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/custom-fields/${id}`)
    }

    /**
     * List custom fields for a specific project (project-scoped endpoint)
     */
    async listByProject(projectId: string, params?: ListCustomFieldsParams): Promise<PaginatedCustomFieldResponse> {
        const response = await this.client.get<PaginatedCustomFieldResponse>(`/projects/${projectId}/custom-fields`, {
            params,
        })
        return response.data
    }
}
